/*************************************************************************
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { APP_THEMES, BUTTON_STYLES } from "../Constants/constants";

const getDefaultButtonColor = (theme = APP_THEMES.LIGHT) =>
  theme === APP_THEMES.LIGHT
    ? BUTTON_STYLES.DEFAULT_LIGHT
    : BUTTON_STYLES.DEFAULT_DARK;
export default getDefaultButtonColor;
